import Vue from "vue"
import VueRouter from "vue-router"
import VueScrollTo from "vue-scrollto"
import Fragment from "vue-fragment"
Vue.use(Fragment.Plugin)
import App from "./App.vue"

import "@/css/style.scss"

Vue.use(VueRouter)
Vue.use(VueScrollTo, {
  duration: 700,
  easing: [0.42, 0.8, 0.58, 1.0],
})

import Home from "./pages/Home.vue"
import KaradaSupport from "./pages/KaradaSupport.vue"
import Personal from "./pages/Personal.vue"
import Detox from "./pages/Detox.vue"
import Calendar from "./pages/Calendar.vue"
import Features from "./pages/Features.vue"
import Pricing from "./pages/Pricing.vue"
import Blog from "./pages/Blog.vue"
import BlogPost from "./pages/BlogPost.vue"
import About from "./pages/About.vue"
import Contact from "./pages/Contact.vue"
import Help from "./pages/Help.vue"
import SignIn from "./pages/SignIn.vue"
import SignUp from "./pages/SignUp.vue"
import ResetPassword from "./pages/ResetPassword.vue"
import PageNotFound from "./pages/PageNotFound.vue"

const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/karada-support",
    component: KaradaSupport,
  },
  {
    path: "/personal-session",
    component: Personal,
  },
  {
    path: "/detox-program",
    component: Detox,
  },
  {
    path: "/calendar",
    component: Calendar,
  },
  {
    path: "/features",
    component: Features,
  },
  {
    path: "/pricing",
    component: Pricing,
  },
  {
    path: "/blog",
    component: Blog,
  },
  {
    path: "/blog-post",
    component: BlogPost,
  },
  {
    path: "/about",
    component: About,
  },
  {
    path: "/contact",
    component: Contact,
  },
  {
    path: "/help",
    component: Help,
  },
  {
    path: "/signin",
    component: SignIn,
  },
  {
    path: "/signup",
    component: SignUp,
  },
  {
    path: "/reset-password",
    component: ResetPassword,
  },
  {
    path: "*",
    component: PageNotFound,
  },
]

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to) {
    return new Promise(() => {
      if (to.hash) {
        window.scroll({ top: 0 })
      } else {
        document.querySelector("html").style.scrollBehavior = "auto"
        window.scroll({ top: 0 })
        document.querySelector("html").style.scrollBehavior = ""
      }
    })
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app")
